import {UILobbyTableController} from './UILobbyTableController'
import {NetworkEnums} from '../../../../../shared/GameEnums'

export class UILobbyController {
    readonly tableController: UILobbyTableController

    private readonly lobbyContainerDiv: HTMLDivElement

    constructor() {
        this.tableController = new UILobbyTableController()

        this.lobbyContainerDiv = document.getElementById('scene_lobby_mid') as HTMLDivElement
    }

    hide() {
        this.lobbyContainerDiv.style.display = 'none'
        this.tableController.hide()
    }

    show() {
        this.lobbyContainerDiv.style.display = 'flex'

        this.tableController.show()
    }

    updateRoomList(data: NetworkEnums.RoomListUpdateData) {
        this.tableController.updateRoomList(data)
    }

    onGotKicked(roomId: string, canRejoin: boolean) {
        this.tableController.onGotKicked(roomId, canRejoin)
    }
}
